import { render, staticRenderFns } from "./userProxy.vue?vue&type=template&id=8ac315c2&scoped=true&"
import script from "./userProxy.vue?vue&type=script&lang=js&"
export * from "./userProxy.vue?vue&type=script&lang=js&"
import style0 from "./userProxy.vue?vue&type=style&index=0&id=8ac315c2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8ac315c2",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\git仓库\\iot_vehicle\\iot_frontend\\iot_supplier\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('8ac315c2')) {
      api.createRecord('8ac315c2', component.options)
    } else {
      api.reload('8ac315c2', component.options)
    }
    module.hot.accept("./userProxy.vue?vue&type=template&id=8ac315c2&scoped=true&", function () {
      api.rerender('8ac315c2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/dialogs/userProxy.vue"
export default component.exports